import type { SessionExpiredTrigger } from '@makemydeal/dr-sales-checkin-store';

export const EXPIRED_SESSION_STATUSES: Record<number, Exclude<SessionExpiredTrigger, 'okta-renewal-failure'>> = {
    401: 'bridge-401',
    403: 'bridge-403'
};
